// Import CSS
import './styles/main.scss'

// Import 3rd Party Modules
import SmoothScroll from 'smooth-scroll'

// Init smooth scroll on anchor links
const scroll = new SmoothScroll('a[href*="#"]', { speed: 100 })

class MobileMenu {
    constructor() {
        this.siteMobileMenu = document.querySelector('.dos-was-here')
        this.siteMobileNavigation = document.querySelector('.site-header__mobile-nav')
        this.init()
        this.events()
    }

    init() {
        let submenuParentItems = this.siteMobileNavigation.querySelectorAll('.menu-item-has-children')

        submenuParentItems.forEach(element => {
            // Create wrapper for link
            element.insertAdjacentHTML('afterbegin',
            `<div class="submenu-toggle__parent"></div>`)

            // Move link into wrapper
            let destination = element.querySelector('.submenu-toggle__parent')
            let moveThis = element.querySelector('a')
            destination.appendChild(moveThis)

            // Create button into wrapper
            destination.insertAdjacentHTML('beforeend', 
            `<button type="button" class="submenu-toggle" aria-label="Toggle submenu">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="var(--color-light-grey)" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>`)
        })
    }

    events() {
        this.siteMobileMenu.addEventListener('click', () => this.siteMobileMenuHandler())

        // Init submenu event listeners after DOM manipulations
        this.submenuToggle = document.querySelectorAll('button.submenu-toggle')
        this.submenuToggle.forEach(link => {
            link.addEventListener('click', (event) => this.toggleSubmenu(event))
        })
    }

    siteMobileMenuHandler() {
        let menuState = document.querySelector('.dos-was-here').getAttribute('aria-expanded')
        let mobileNavState =  document.querySelector('.site-header__mobile-nav').classList.contains('active')
    
        menuState === 'false' ? this.siteMobileMenu.setAttribute('aria-expanded', 'true') : this.siteMobileMenu.setAttribute('aria-expanded', 'false')
        mobileNavState === false ? this.siteMobileNavigation.classList.add('active') : this.siteMobileNavigation.classList.remove('active')
    }

    toggleSubmenu(event) {
        // Select current submenu
        let submenu = event.target.parentElement
        // Change state accordingly
        !submenu.classList.contains('active') ? submenu.classList.add('active') : submenu.classList.remove('active')
    }
}

const mobileMenu = new MobileMenu()

const modalOpenTriggers = document.querySelectorAll('[data-modal-target]')
const modalCloseTriggers = document.querySelectorAll('[data-modal-close]')

modalOpenTriggers.forEach(item => {
    const dataId = item.dataset.modalTarget
    item.addEventListener('click', () => openModal(dataId))
})

modalCloseTriggers.forEach(item => {
    const dataId = item.dataset.modalClose
    item.addEventListener('click', () => closeModal(dataId))
})

function openModal(dataId) {
    const data = dataId
    const target = document.querySelector(`[data-modal-id="${data}"]`)
    
    target.classList.remove('hidden')
    setTimeout(() => {
        target.classList.add('open')
    }, 20)
    bodyDoc.classList.add('no-scroll')
}

function closeModal(dataId) {
    const data = dataId
    const target = document.querySelector(`[data-modal-id="${data}"]`)
    
    target.classList.remove('open')
    setTimeout(() => {
        target.classList.add('hidden')
    }, 200)
    bodyDoc.classList.remove('no-scroll')
}

function modalKeyPressHandler(event) {
    const modalIsOpen = document.querySelector('.modal.open')
    let dataId
    if (modalIsOpen) {
        dataId = modalIsOpen.dataset.modalId
    }

    if (event.keyCode == 27 && modalIsOpen) {
        closeModal(dataId)
    }
}

document.addEventListener('keyup', event => modalKeyPressHandler(event))